import React from 'react';
import Search from './Search';
import NewsInfoTab from './newsInfo/NewsInfoTab';
import AuditInfoTab from './auditInfo/AuditInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'

class NewsSetup extends React.Component {
    render() {
        let opts = {
            title: "News Setup",
            description: "Create and modify the news & updates that appears on the login page",
            addPrivilege: App.hasPrivilege("AdminNewsSetupAdd"),
            addNewTitle: "Add news",
            helpKey: Help.newsSetupHelpKey,
            recentType: "news",
            list: {
                url: API.App.url('/newsSetup/search'),
                rowKey: "newsId",
                columns: [
                    { key: 'description', name: 'News Title', sortable: false },
                    { key: 'startDate', name: 'Start publish date', width: 140, sortable: true, formatter: Formatter.Date, cellClass: "text-center" },
                    { key: 'endDate', name: 'End publish date', width: 140, sortable: true, formatter: Formatter.Date, cellClass: "text-center" },
                    { key: 'active', name: 'Active', formatter: Formatter.Check, width: 100, cellClass: "text-center" }
                ]
            },
            tabs: [
                { key: "newsInfo", title: "News Info", comp: NewsInfoTab, helpKey:Help.newsSetupInfoHelpKey },
                { key: "auditInfo", title: "Audit Info", comp: AuditInfoTab, helpKey: Help.newsSetupAuditHelpKey } 
            ]
        };

        opts = Object.assign(opts, this.props);

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}

export default NewsSetup;



// WEBPACK FOOTER //
// ./src/areas/admin/newsSetup/NewsSetup.js